import { Button, CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'
import { CalQtySack } from '../services/stockService'

export default function ConfirmDialogAdjust({ open, setOpen, rows, handleAdd, adjust, adjustType, loadingSubmit }) {

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            รายการปรับปรุงยอด {/* {{data?.header}} */}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-borderless  ">
                            <thead>
                                <tr>
                                    <th scope="col " class="text-center">ที่</th>
                                    <th scope="col " class="text-center w-300">เมล็ดพันธุ์</th>
                                    <th scope="col " class="text-center">ชั้นพันธุ์</th>
                                    <th scope="col " class="text-center">ฤดู</th>
                                    <th scope="col " class="text-center">ชนิดข้าว</th>
                                    <th scope="col " class="text-center">สารเคมี</th>

                                    <th scope="col " class="text-center"> ปีที่ผลิต</th>

                                    <th scope="col " class="text-center">ล็อตที่</th>
                                    <th scope="col ">จำนวน (กระสอบ)</th>
                                    {!adjust && !adjustType ? <th scope="col " class="text-center">ปริมาณก่อนปรับปรุง</th> : null}
                                    <th scope="col " class="text-center">ปรับปรุง</th>

                                    <th scope="col " class="text-center">โรงเก็บที่</th>
                                    <th scope="col " class="text-center">ราคาจำหน่าย</th>
                                    <th scope="col " class="text-center">ต้นทุนการผลิต</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {!adjustType && rows?.map((creds, i) => (

                                    <tr>
                                        <td>{i + 1}.</td>

                                        <td class="text-center">{creds?.ItemNo?.ItemNo?.ItemName || creds?.ItemNo?.ItemName}</td>

                                        <td class="text-center">{creds?.ItemNo?.ItemNo?.Option2 || creds?.ItemNo?.Option2}</td>
                                        <td class="text-center">
                                            <span style={{ fontWeight: 'bold', color: creds?.ItemNo?.ItemNo?.Season === 'ฝน'||  creds?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown' }}>{creds?.ItemNo?.ItemNo?.Season || creds?.ItemNo?.Season} </span>
                                        </td>
                                        <td class="text-center">{creds?.ItemNo?.ItemNo?.Option1 || creds?.ItemNo?.Option1}</td>
                                        <td class="text-center">{creds?.ItemNo?.ItemNo?.Chemical || creds?.ItemNo?.Chemical}</td>


                                        <td class="text-center">
                                            {creds.Year}
                                        </td>

                                        <td class="text-center">{creds.Lot}</td>
                                        <td class="text-center">{CalQtySack(creds?.ItemNo?.Option2, creds.Qty.toString().replaceAll(',', ''))?.toLocaleString()}</td>
                                        {!adjust && !adjustType ? <td class="text-center">{creds.Balance?.toLocaleString()}</td> : null}
                                        <td class="text-center">{creds?.Qty}</td>


                                        <td class="text-center">{creds?.WarehouseNo?.WarehouseName}/{
                                            creds?.ZoneNo?.ZoneName}</td>



                                        <td class="text-center">{creds?.ItemNo?.SalePrice}</td>
                                        <td class="text-center">{creds.CostPrice?.toLocaleString()}</td>

                                    </tr>))
                                }

                                {adjustType && rows?.map((creds, i) => (
                                    <tr >
                                        <td>{i + 1}.</td>
                                        <td class="text-center">
                                            {creds?.ItemNo?.ItemName}
                                        </td>
                                        <td class="text-center">{creds?.ItemNo?.Option2}</td>
                                        <td class="text-center">
                                            <span style={{ fontWeight: 'bold', color: creds?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown' }}>{creds?.ItemNo?.Season} </span>
                                        </td>
                                        <td class="text-center">{creds?.ItemNo?.Option1}</td>
                                        <td class="text-center">{creds?.ItemNo?.Chemical}</td>
                                        <td class="text-center">{creds.Year}</td>


                                        <td class="text-center">{creds?.LotGen}{creds?.Lot}</td>

                                        <td class="text-center">{CalQtySack(creds?.ItemNo?.Option2, creds?.Qty)}</td>

                                        <td class="text-center">{creds?.Qty}</td>


                                        <td class="text-center">{creds?.WarehouseNo?.WarehouseName || creds?.zones?.WarehouseNo?.WarehouseName}/{
                                            creds?.ZoneNo?.ZoneName || creds?.zones?.ZoneName}</td>



                                        <td class="text-center">{creds?.ItemNo?.SalePrice}</td>
                                        <td class="text-center">{creds?.CostPrice.toLocaleString()}</td>
                                    </tr >))
                                }
                            </tbody >
                        </table >
                    </div >


                </div >
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>ยืนยันการทำรายการ</Button>
                        <Button disabled={loadingSubmit} onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>{loadingSubmit ? <CircularProgress size={'24px'} color="inherit" /> : 'ยืนยันการทำรายการ'}</Button>


                    </div>
                </div>
            </DialogContent >
        </Dialog >
    )
}
